import {AlertMessage} from 'Core/components/Alerts/AlertsModal';
import {AlertPayload} from 'Core/ducks/alerts';
import {Page} from 'Core/models/Page';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {get, post, put, remove} from 'Shared/utilities/fetchHelpers';

const ALERT_ROOT_URI = '/alerts';

export default {
  getAlerts: (filter: any) => get<Page<AlertPayload>>(`${ALERT_ROOT_URI}${addFilterParameters(filter)}`),
  getAlert: (alertId: string) => get<AlertPayload>(`${ALERT_ROOT_URI}/${alertId}`),
  deleteAlert: (alertId: string) => remove(`${ALERT_ROOT_URI}/${alertId}`),
  updateAlert: (alert: AlertPayload) => put<AlertPayload>(`${ALERT_ROOT_URI}`, alert),
  saveAlert: (alert: AlertPayload) => post<AlertPayload>(`${ALERT_ROOT_URI}`, alert),
};
